import React, { useState } from 'react';
import { 
  AIExpertStep1Upload, 
  AIExpertStep2Analysis, 
  AIExpertStep3RiskDetection 
} from './AIImmigrationExpert';
import { 
  AIExpertStep4Recommendations, 
  AIExpertStep5QASession 
} from './AIImmigrationExpert2';
import { 
  AIExpertStep6DocumentPrep, 
  AIExpertStep7FinalScoring 
} from './AIImmigrationExpert3';
import { 
  AIExpertStep8FinalPackage 
} from './AIImmigrationExpert4';

export const AIImmigrationExpertFlow = ({ isOpen, onClose }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    uploadedFiles: [],
    analysisResults: null,
    riskResults: null,
    recommendations: [],
    selectedActions: [],
    qaAnswers: {},
    additionalUploads: [],
    documentLabels: [],
    templates: {},
    finalScores: null,
    finalPackage: null,
    applicantName: '',
    caseType: ''
  });

  const steps = [
    'Upload Case Files',
    'AI File Analysis & Evidence Assessment',
    'Advanced Risk Detection',
    'Personalized Improvement Recommendations',
    'Interactive Q&A & Document Upload Cycle',
    'Document Preparation & Labeling',
    'Final Case Scoring',
    'Final Review & Packet Generation'
  ];

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-gray-900 rounded-lg max-w-6xl w-full max-h-[95vh] overflow-y-auto">
        <div className="p-6">
          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center">
              <span className="text-3xl mr-4">🤖</span>
              <div>
                <h2 className="text-2xl font-bold text-white">AI Immigration Expert</h2>
                <p className="text-gray-400">Comprehensive Case Analysis & Evidence Optimization</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-white text-2xl"
            >
              ×
            </button>
          </div>

          {/* Progress Bar */}
          <div className="mb-8">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm text-gray-400">Step {currentStep + 1} of {steps.length}</span>
              <span className="text-sm text-gray-400">{Math.round((currentStep / (steps.length - 1)) * 100)}% Complete</span>
            </div>
            <div className="w-full bg-gray-700 rounded-full h-2">
              <div 
                className="bg-gradient-to-r from-blue-500 to-purple-500 h-2 rounded-full transition-all duration-300"
                style={{ width: `${(currentStep / (steps.length - 1)) * 100}%` }}
              ></div>
            </div>
            <p className="text-white font-medium mt-2">{steps[currentStep]}</p>
          </div>

          {/* Step Content */}
          {currentStep === 0 && (
            <AIExpertStep1Upload 
              formData={formData} 
              setFormData={setFormData} 
              onNext={handleNext} 
            />
          )}
          {currentStep === 1 && (
            <AIExpertStep2Analysis 
              formData={formData} 
              setFormData={setFormData} 
              onNext={handleNext} 
              onBack={handleBack} 
            />
          )}
          {currentStep === 2 && (
            <AIExpertStep3RiskDetection 
              formData={formData} 
              setFormData={setFormData} 
              onNext={handleNext} 
              onBack={handleBack} 
            />
          )}
          {currentStep === 3 && (
            <AIExpertStep4Recommendations 
              formData={formData} 
              setFormData={setFormData} 
              onNext={handleNext} 
              onBack={handleBack} 
            />
          )}
          {currentStep === 4 && (
            <AIExpertStep5QASession 
              formData={formData} 
              setFormData={setFormData} 
              onNext={handleNext} 
              onBack={handleBack} 
            />
          )}
          {currentStep === 5 && (
            <AIExpertStep6DocumentPrep 
              formData={formData} 
              setFormData={setFormData} 
              onNext={handleNext} 
              onBack={handleBack} 
            />
          )}
          {currentStep === 6 && (
            <AIExpertStep7FinalScoring 
              formData={formData} 
              setFormData={setFormData} 
              onNext={handleNext} 
              onBack={handleBack} 
            />
          )}
          {currentStep === 7 && (
            <AIExpertStep8FinalPackage 
              formData={formData} 
              setFormData={setFormData} 
              onNext={handleNext} 
              onBack={handleBack} 
              onClose={onClose}
            />
          )}
        </div>
      </div>
    </div>
  );
};